import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function MyEditor({ editorContent, onChange }) {
  return (
    <div className="editor_wrapper">
      <CKEditor
        editor={ClassicEditor}
        data={editorContent}
        onReady={(editor) => {
          // You can store the "editor" and use when it is needed.
        }}
        editorConfig={{
          allowedContent: true,
          extraAllowedContent: "style",
        }}
        onChange={onChange} 
        // config={{
        //   extraPlugins: [MyCustomUploadAdapterPlugin],
        //   toolbar: [
        //     "heading",
        //     "|",
        //     "bold",
        //     "italic",
        //     "link",
        //     "bulletedList",
        //     "numberedList",
        //     "blockQuote",
        //     "insertTable",
        //     "uploadImage",
        //     "undo",
        //     "redo",
        //   ],
        // }}
      />
    </div>
  );
}


// function MyCustomUploadAdapterPlugin(editor) {
//   editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
//     return new MyUploadAdapter(loader);
//   };
// }

// // Implement upload adapter
// class MyUploadAdapter {
//   constructor(loader) {
//     this.loader = loader;
//   }

//   upload() {
//     return this.loader.file.then(
//       (file) =>
//         new Promise((resolve, reject) => {
//           const data = new FormData();
//           data.append("file", file);

//           fetch(`${process.env.REACT_APP_IMAGE_URL}/upload`, {
//             method: "POST",
//             body: data,
//           })
//             .then((res) => res.json())
//             .then((res) => {
//               // Expected: res.url should contain uploaded image URL
//               resolve({
//                 default: res.url,
//               });
//             })
//             .catch((err) => {
//               reject(err);
//             });
//         })
//     );
//   }

//   abort() {
//     // Handle abort if needed
//   }
// }

export default MyEditor;
